<template>
  <div class="statistics_inner_wrap d-flex flex-wrap justify-center" style="margin-top: 40px">
    <search-form title="환자잇몸상태" @reset="reset" @search="search"></search-form>
    <v-card class="chart_card subscription_rate_chart_wrap mt-5" width="1360">
      <div class="chart_header">
        <div class="d-flex align-center">
          <i class="icon status_list"></i>
          전체 남녀 가입률
        </div>
        <div>남녀 가입률 산출 기준은 앱 가입일입니다.</div>
      </div>
      <div class="chart_wrap d-flex">
        <div v-for="(item, index) in subscriptionRate" :key="index" class="chart_box" :class="{ margin: index !== 0 }">
          <div class="doughnut_chart_box">
            <status-doughnut-chart :description="item.description" :number="item.number" unit="명" :chart-data="item.chartData"></status-doughnut-chart>
          </div>
          <div>{{ item.chartLabel }}</div>
        </div>
      </div>
    </v-card>
    <v-card class="chart_card oral_status_chart_wrap mt-5" width="1360">
      <div class="chart_header">
        <div class="d-flex align-center">
          <i class="icon status_list"></i>
          병원 평균 잇몸촬영 동향
        </div>
      </div>
      <no-data-box v-if="data.takeCount === 0"></no-data-box>
      <template v-else>
        <div class="status_summary_wrap d-flex align-center">
          <i class="icon mr-3" :class="data.averageState ? `icon_${healthStatus[data.averageState].icon}` : `icon_norecord`"></i>
          <div class="status_text">
            <div>병원 내 평균 잇몸상태는 {{ data.averageState ? healthStatus[data.averageState].text : '' }}입니다.</div>
            <span>전체 잇몸 촬영횟수</span>
            <span>{{ `${data.takeCount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 회 (환자당 평균 {{ data.takeAverage }}회 촬영)</span>
          </div>
        </div>
        <div class="chart_wrap d-flex">
          <div v-for="(item, index) in oralStatus" :key="index" class="chart_box" :class="{ margin: index !== 0 }">
            <div class="doughnut_chart_box">
              <status-doughnut-chart :description="item.description" :number="item.number" unit="명" :chart-data="item.chartData"></status-doughnut-chart>
            </div>
            <div>{{ item.chartLabel }}</div>
          </div>
        </div>
      </template>
    </v-card>
    <v-card class="chart_card mt-5" width="1360">
      <div class="chart_header">
        <div class="d-flex align-center">
          <i class="icon status_list"></i>
          병원 평균 잇몸상태 추이
        </div>
      </div>
      <div class="chart_wrap">
        <no-data-box v-if="data.daily.length === 0"></no-data-box>
        <status-line-bar-chart v-else :daily="data.daily" parent="statistics"></status-line-bar-chart>
      </div>
    </v-card>
    <!--<v-card width="1360" class="mt-5 table_wrap">-->
    <!--  <v-data-table-->
    <!--    :headers="statisticsRankListHeaders"-->
    <!--    no-data-text="데이터가 존재하지 않습니다."-->
    <!--    :items="data.rank"-->
    <!--    :items-per-page="data.rank.length"-->
    <!--    fixed-header-->
    <!--    hide-default-footer-->
    <!--    class="table_wrap"-->
    <!--    :loading="tableLoading">-->
    <!--    <template #item="{ item, index }">-->
    <!--      <tr>-->
    <!--        <td>{{ index + 1 }}</td>-->
    <!--        <td>{{ item.corName }}</td>-->
    <!--        <td>{{ item.name }}</td>-->
    <!--        <td>{{ `${item.count}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>-->
    <!--        <td :style="{ color: healthStatus[item.state].color }">{{ healthStatus[item.state].text }}</td>-->
    <!--        <td>{{ item.oralConditionRank }} 등 / {{ `${item.headcount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 명</td>-->
    <!--        <td>{{ $convertDateFormat('YYYYMMDDAMPMKR', item.latestDate) }}</td>-->
    <!--      </tr>-->
    <!--    </template>-->
    <!--  </v-data-table>-->
    <!--</v-card>-->
  </div>
</template>

<script>
import SearchForm from '@/components/statistics/SearchForm';
import StatusDoughnutChart from '@/components/status/StatusDoughnutChart';
import StatusLineBarChart from '@/components/status/StatusLineBarChart';
import NoDataBox from '@/components/common/NoDataBox';
import Api from '@/apis/api';
import { mapState } from 'vuex';

export default {
  name: 'PeriodStatistics',
  components: {
    SearchForm,
    StatusDoughnutChart,
    StatusLineBarChart,
    NoDataBox,
  },
  data: () => ({
    data: {
      genderCount: {},
      takeCount: 0,
      takeAverage: 0,
      averageState: '',
      corpsCount: {},
      daily: [],
      rank: [],
    },
    tableLoading: false,
    subscriptionRate: [],
    oralStatus: [],
  }),
  computed: {
    ...mapState('commonValue', ['healthStatus', 'statisticsRankListHeaders']),
  },
  watch: {
    '$route.query'() {
      this.getListStatisticsPeriod();
    },
  },
  created() {
    this.getListStatisticsPeriod();
  },
  methods: {
    getListStatisticsPeriod() {
      this.$root.spinner.set(true);
      this.tableLoading = true;
      let form = {};
      for (const i in this.$route.query) {
        if (i !== 'active') form[i] = this.$route.query[i];
      }
      Api.getStatisticsPeriod(form).then(res => {
        if (res && res.data.rt === 200) {
          for (const key in this.data) {
            this.data[key] = res.data[key];
          }
          this.setSubscriptionRate();
          this.setOralStatus();
          this.tableLoading = false;
          this.$root.spinner.set(false);
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    setSubscriptionRate() {
      this.subscriptionRate.push(
        {
          chartLabel: '전체 가입자 수',
          description: `100%`,
          number: this.data.genderCount.countAll,
          chartData: {
            datasets: [
              {
                data: [this.data.genderCount.countM, this.data.genderCount.countW],
                backgroundColor: ['#337eff', '#e64e81'],
              },
            ],
          },
        },
        {
          chartLabel: '남자 가입자 수',
          description: `${Math.round((this.data.genderCount.countM / this.data.genderCount.countAll) * 100)}%`,
          number: this.data.genderCount.countM,
          chartData: {
            datasets: [
              {
                data: [this.data.genderCount.countM, this.data.genderCount.countAll - this.data.genderCount.countM],
                backgroundColor: ['#337eff', '#dadee6'],
              },
            ],
          },
        },
        {
          chartLabel: '여자 가입자 수',
          description: `${Math.round((this.data.genderCount.countW / this.data.genderCount.countAll) * 100)}%`,
          number: this.data.genderCount.countW,
          chartData: {
            datasets: [
              {
                data: [this.data.genderCount.countW, this.data.genderCount.countAll - this.data.genderCount.countW],
                backgroundColor: ['#e64e81', '#dadee6'],
              },
            ],
          },
        },
      );
    },
    setOralStatus() {
      this.oralStatus.push(
        {
          chartLabel: '잇몸촬영 환자수',
          description: `100%`,
          number: this.data.corpsCount.countAll,
          chartData: {
            datasets: [
              {
                data: [this.data.corpsCount.countS, this.data.corpsCount.countG, this.data.corpsCount.countA, this.data.corpsCount.countD],
                backgroundColor: ['#337eff', '#27c4aa', '#fcb519', '#e64e81'],
              },
            ],
          },
        },
        {
          chartLabel: this.healthStatus.S.text,
          description: `${Math.round((this.data.corpsCount.countS / this.data.corpsCount.countAll) * 100)}%`,
          number: this.data.corpsCount.countS,
          chartData: {
            datasets: [
              {
                data: [this.data.corpsCount.countS, this.data.corpsCount.countAll - this.data.corpsCount.countS],
                backgroundColor: ['#337eff', '#dadee6'],
              },
            ],
          },
        },
        {
          chartLabel: this.healthStatus.G.text,
          description: `${Math.round((this.data.corpsCount.countG / this.data.corpsCount.countAll) * 100)}%`,
          number: this.data.corpsCount.countG,
          chartData: {
            datasets: [
              {
                data: [this.data.corpsCount.countG, this.data.corpsCount.countAll - this.data.corpsCount.countG],
                backgroundColor: ['#27c4aa', '#dadee6'],
              },
            ],
          },
        },
        {
          chartLabel: this.healthStatus.A.text,
          description: `${Math.round((this.data.corpsCount.countA / this.data.corpsCount.countAll) * 100)}%`,
          number: this.data.corpsCount.countA,
          chartData: {
            datasets: [
              {
                data: [this.data.corpsCount.countA, this.data.corpsCount.countAll - this.data.corpsCount.countA],
                backgroundColor: ['#fcb519', '#dadee6'],
              },
            ],
          },
        },
        {
          chartLabel: this.healthStatus.D.text,
          description: `${Math.round((this.data.corpsCount.countD / this.data.corpsCount.countAll) * 100)}%`,
          number: this.data.corpsCount.countD,
          chartData: {
            datasets: [
              {
                data: [this.data.corpsCount.countD, this.data.corpsCount.countAll - this.data.corpsCount.countD],
                backgroundColor: ['#e64e81', '#dadee6'],
              },
            ],
          },
        },
      );
    },
    reset() {
      if (JSON.stringify(this.$route.query) !== JSON.stringify({})) {
        this.$router.push({ query: null });
      }
    },
    search(data) {
      let query = {};
      for (const i in data) {
        if (data[i]) {
          query[i] = data[i];
        } else {
          delete query[i];
        }
      }
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.push({ query: query });
      }
    },
  },
};
</script>

<style scoped></style>
